import { useEffect, useCallback } from 'react';
import { useMerchFilters } from './useMerchFilters';
import { useMerchPagination } from './useMerchPagination';
import { useMerchApi } from './useMerchApi';

interface UseMerchListParams {
  itemsPerPage: number;
}

const useMerchList = ({ itemsPerPage }: UseMerchListParams) => {
  const { agencyFilter, categoryFilter, handleAgencyFilterChange, handleCategoryFilterChange } =
    useMerchFilters();

  const { currentPage, onPageChange, setCurrentPage } = useMerchPagination(1);

  const { merchData, fetchMerch, deleteMerch } = useMerchApi({
    agencyFilter,
    categoryFilter,
    currentPage,
    itemsPerPage,
  });

  const onAgencyFilterChange = useCallback(
    (value: string) => {
      handleAgencyFilterChange(value);
      setCurrentPage(1);
    },
    [handleAgencyFilterChange, setCurrentPage]
  );

  const onCategoryFilterChange = useCallback(
    (value: string) => {
      handleCategoryFilterChange(value);
      setCurrentPage(1);
    },
    [handleCategoryFilterChange, setCurrentPage]
  );

  useEffect(() => {
    fetchMerch();
  }, [fetchMerch]);

  return {
    agencyFilter,
    categoryFilter,
    currentPage,
    merchData,
    onAgencyFilterChange,
    onCategoryFilterChange,
    onPageChange,
    onDeleteMerch: deleteMerch,
    fetchMerch,
  };
};

export default useMerchList;
